export interface DynamicField {
  label: string;
  /** Merge-tag path inserted as `{{token}}`: the `contact.*` keys the email editor uses. */
  token: string;
}

export interface DynamicFieldGroup {
  fields: DynamicField[];
  title: string;
}

export const DYNAMIC_FIELD_GROUPS: DynamicFieldGroup[] = [
  {
    title: 'Recipient data',
    fields: [
      { label: 'Address', token: 'contact.address' },
      { label: 'City', token: 'contact.city' },
      { label: 'Company', token: 'contact.company' },
      { label: 'Date of birth', token: 'contact.dateOfBirth' },
      { label: 'Email', token: 'contact.email' },
      { label: 'First name', token: 'contact.firstName' },
      { label: 'Last name', token: 'contact.lastName' },
      { label: 'Phone', token: 'contact.phone' },
      { label: 'State / province', token: 'contact.state' },
      { label: 'Zip / postal code', token: 'contact.zipCode' },
    ],
  },
];

export const formatDynamicFieldToken = (field: DynamicField) => `{{${field.token}}}`;

/** Groups narrowed to the fields whose label holds `search` (any case); empty groups drop out. */
export function filterDynamicFieldGroups(
  groups: DynamicFieldGroup[],
  search: string,
): DynamicFieldGroup[] {
  const query = search.trim().toLowerCase();
  if (!query) {
    return groups;
  }

  return groups
    .map((group) => ({
      ...group,
      fields: group.fields.filter((field) => field.label.toLowerCase().includes(query)),
    }))
    .filter((group) => group.fields.length > 0);
}
